export default {
    pageTitle: 'DASHBOARD'
}
